module.exports = __webpack_public_path__ + "static/media/icon-building-dark.1920773e.svg";